import { ReactNode } from 'react';
import {
  PiInstagramLogo,
  PiTelegramLogo,
  PiWhatsappLogo,
  PiTwitterLogo,
  PiDiscordLogo,
  PiTiktokLogo,
  PiSkypeLogo,
  PiFacebookLogo,
  PiLinkedinLogo,
  PiMapPinLine,
  PiGlobeSimple,
  PiYoutubeLogo,
  PiShoppingCartSimple,
  PiStorefront,
} from 'react-icons/pi';
import { AiOutlineTwitter, AiOutlineInstagram, AiFillFacebook,AiFillLinkedin } from "react-icons/ai";

import VkLogo from '../assets/svg/vk.svg';

export const defaultSocialIcon = <PiGlobeSimple />;
export const companySocialIcons: Record<string, ReactNode> = {
  instagram: <PiInstagramLogo />,
  telegram: <PiTelegramLogo />,
  whatsapp: <PiWhatsappLogo />,
  twitter: <PiTwitterLogo />,
  discord: <PiDiscordLogo />,
  vk: <VkLogo />,
  tiktok: <PiTiktokLogo />,
  tikTok: <PiTiktokLogo />,
  skype: <PiSkypeLogo />,
  facebook: <PiFacebookLogo />,
  linkedin: <PiLinkedinLogo />,
  '2gis': <PiMapPinLine />,
  youtube: <PiYoutubeLogo />,
  googlemaps: <PiMapPinLine />,
  yandexmaps: <PiMapPinLine />,
  otzovik: <PiStorefront />,
  yandexmarket: <PiShoppingCartSimple />,
  kaspi: <PiShoppingCartSimple />,
  wildberries: <PiShoppingCartSimple />,
  ozon: <PiShoppingCartSimple />,
};

export const userSocialIcons: Record<string, ReactNode> = {
  Instagram: <AiOutlineInstagram />,
  Twitter: <AiOutlineTwitter />,
  Facebook: <AiFillFacebook />,
  LinkedIn: <AiFillLinkedin />,
};

export const getSocialIcon = (iconKey: string): ReactNode => {
  // Явная обработка ключей, начинающихся с цифры
  if (iconKey === '2gis') {
    return companySocialIcons['2gis'] || defaultSocialIcon;
  }
  return companySocialIcons[iconKey] || defaultSocialIcon;
};
